import React from 'react';
import CustomButton from '../../../common/components/CustomButton';
import KaraokeModificationFormView2ModificationItemView from './KaraokeModificationFormView2ModificationItemView';
import { FieldValidationErrorsType } from '../../../common/form/FrekulForm';

type KaraokeModificationFormView2ModificationViewFieldName =
  'modification_item1'|'modification_item2'|'modification_item3'|
  'modification_details1'|'modification_details2'|'modification_details3';

export default function KaraokeModificationFormView2ModificationView({
  getValue,
  setValue,
  getErrors,
  onNext,
} : {
  getValue: (name: KaraokeModificationFormView2ModificationViewFieldName) => string,
  setValue: (name: KaraokeModificationFormView2ModificationViewFieldName, value: string) => void,
  getErrors: (name: KaraokeModificationFormView2ModificationViewFieldName) => FieldValidationErrorsType,
  onNext: () => void,
}) {
  const [count, setCount] = React.useState(1);

  React.useEffect(() => {
    if (getValue('modification_item3') !== '' || getValue('modification_details3') !== '') {
      setCount(3);
    } else if (getValue('modification_item2') !== '' || getValue('modification_details2') !== '') {
      setCount(2);
    }
  }, []);
  return (
    <form>
      <div className="form__body">
        <KaraokeModificationFormView2ModificationItemView
          itemName="modification_item1"
          detailsName="modification_details1"
          getValue={getValue}
          setValue={setValue}
          getErrors={getErrors}
        />
        {count >= 2 && (
          <KaraokeModificationFormView2ModificationItemView
            itemName="modification_item2"
            detailsName="modification_details2"
            getValue={getValue}
            setValue={setValue}
            getErrors={getErrors}
          />
        )}
        {count >= 3 && (
          <KaraokeModificationFormView2ModificationItemView
            itemName="modification_item3"
            detailsName="modification_details3"
            getValue={getValue}
            setValue={setValue}
            getErrors={getErrors}
          />
        )}
        {count < 3 && (
          <dl>
            <dt />
            <dd>
              <CustomButton type="add" onClick={() => setCount(count + 1)}>追加</CustomButton>
            </dd>
          </dl>
        )}
        <p className="top_line" />
        <ul>
          <li className="bt">
            <CustomButton type="default" onClick={() => onNext()}>確認画面へ</CustomButton>
          </li>
        </ul>
        <p>
          こちらは修正依頼の窓口です。質問やその他の連絡は
          <a href="/contact">こちら</a>
          から
        </p>
      </div>
    </form>
  );
}

